export interface AreaColor {
  color: string;
  tint: string;
  border: string;
  label: string;
}

export const AREA_COLORS: Record<string, AreaColor> = {
  // i18n-ok: nombres propios de las áreas/equipos de Winclap
  branding:     { color: '#111111', tint: '#F5F5F5', border: '#E5E5E5', label: 'Branding' },
  // i18n-ok: nombres propios de las áreas/equipos de Winclap
  business:     { color: '#999999', tint: '#F7F7F7', border: '#E0E0E0', label: 'Business' },
  // i18n-ok: nombres propios de las áreas/equipos de Winclap
  cleaning:     { color: '#1CC9B9', tint: '#E5F9F7', border: '#A8E4DF', label: 'Cleaning Services' },
  // i18n-ok: nombres propios de las áreas/equipos de Winclap
  creative:     { color: '#8B5CF6', tint: '#F3EEFF', border: '#D5C4FF', label: 'Creative Studio' },
  // i18n-ok: nombres propios de las áreas/equipos de Winclap
  data:         { color: '#0EA5E9', tint: '#EBF7FF', border: '#A8D8EE', label: 'Data' },
  // i18n-ok: nombres propios de las áreas/equipos de Winclap
  executive:    { color: '#000000', tint: '#F0F0F0', border: '#CCCCCC', label: 'Executive' },
  // i18n-ok: nombres propios de las áreas/equipos de Winclap
  finance:      { color: '#B45309', tint: '#FFFAE6', border: '#FFE57A', label: 'Finance & Strategy' },
  // i18n-ok: nombres propios de las áreas/equipos de Winclap
  growth:       { color: '#B45309', tint: '#FFFAE6', border: '#FFE57A', label: 'Growth Strategy' },
  // i18n-ok: nombres propios de las áreas/equipos de Winclap
  ownedmedia:   { color: '#C2410C', tint: '#FFF0EB', border: '#F7B99E', label: 'Owned Media Lab' },
  // i18n-ok: nombres propios de las áreas/equipos de Winclap
  paidmedia:    { color: '#DC2626', tint: '#FEF1EC', border: '#F7B99E', label: 'Paid Media Lab' },
  // i18n-ok: nombres propios de las áreas/equipos de Winclap
  partnerships: { color: '#0D9488', tint: '#E5F9F7', border: '#A8E4DF', label: 'Partnerships & Marketing' },
  // i18n-ok: nombres propios de las áreas/equipos de Winclap
  people:       { color: '#C2410C', tint: '#FFF0EB', border: '#F7B99E', label: 'People' },
  // Platform roles
  // i18n-ok: nombres propios de las áreas/equipos de Winclap
  admin:        { color: '#111111', tint: '#F5F5F5', border: '#E5E5E5', label: 'Admin' },
  // i18n-ok: nombres propios de las áreas/equipos de Winclap
  tech:         { color: '#0EA5E9', tint: '#EBF7FF', border: '#A8D8EE', label: 'Tech' },
  // i18n-ok: nombres propios de las áreas/equipos de Winclap
  clapper:      { color: '#8B5CF6', tint: '#F3EEFF', border: '#D5C4FF', label: 'Clapper' },
  // i18n-ok: nombres propios de las áreas/equipos de Winclap
  user:         { color: '#555555', tint: '#F7F7F7', border: '#E0E0E0', label: 'User' },
};

export const ROLE_TO_AREA: Record<string, string> = {
  admin: 'admin',
  tech: 'tech',
  finance: 'finance',
  people: 'people',
  growth: 'growth',
  clapper: 'clapper',
  user: 'user',
  branding: 'branding',
  business: 'business',
  creative: 'creative',
  data: 'data',
  executive: 'executive',
  ownedmedia: 'ownedmedia',
  paidmedia: 'paidmedia',
  partnerships: 'partnerships',
};

export function getAreaColor(role: string): AreaColor {
  const area = ROLE_TO_AREA[role] ?? 'user';
  return AREA_COLORS[area] ?? AREA_COLORS['user'];
}

// Background tints per area (for badge chip backgrounds using Winclap brand hex values)
export const AREA_BG_COLORS: Record<string, { bg: string; text: string; border: string }> = {
  creative:     { bg: '#CEABFF', text: '#3B0764', border: '#D5C4FF' },
  data:         { bg: '#87DBFF', text: '#0C4A6E', border: '#A8D8EE' },
  finance:      { bg: '#FFD447', text: '#713F12', border: '#FFE57A' },
  growth:       { bg: '#FFD447', text: '#713F12', border: '#FFE57A' },
  ownedmedia:   { bg: '#FFA88E', text: '#7C2D12', border: '#F7B99E' },
  paidmedia:    { bg: '#FE805B', text: '#7C2D12', border: '#F7B99E' },
  partnerships: { bg: '#1CC9B9', text: '#134E4A', border: '#A8E4DF' },
  cleaning:     { bg: '#1CC9B9', text: '#134E4A', border: '#A8E4DF' },
  people:       { bg: '#FFA88E', text: '#7C2D12', border: '#F7B99E' },
  branding:     { bg: '#E5E5E5', text: '#111111', border: '#CCCCCC' },
  executive:    { bg: '#E5E5E5', text: '#000000', border: '#CCCCCC' },
  admin:        { bg: '#F5F5F5', text: '#111111', border: '#E5E5E5' },
  tech:         { bg: '#87DBFF', text: '#0C4A6E', border: '#A8D8EE' },
  clapper:      { bg: '#CEABFF', text: '#3B0764', border: '#D5C4FF' },
  business:     { bg: '#F0F0F0', text: '#555555', border: '#E0E0E0' },
  user:         { bg: '#F0F0F0', text: '#555555', border: '#E0E0E0' },
};

export function getAreaBadgeStyle(role: string): { bg: string; text: string; border: string } {
  const area = ROLE_TO_AREA[role] ?? 'user';
  return AREA_BG_COLORS[area] ?? AREA_BG_COLORS['user'];
}
